const endpoints = {
  saveVCard: "/v1/auth/agency/vcard",
  updateAgencyName: "/v1/auth/agency/user",
  agencySettings: "/v1/auth/agency/settings",
  employeeHistory: "/v1/auth/agency/employee/history",
  employee: "/v1/auth/agency/employee/escalation/details",
  employeeEscalations: "/v1/auth/agency/employee/escalations",
  rosterStats: "/v1/auth/agency/employee/stats-numbers/roster",
  reportsHighlights: "/v1/auth/agency/employee/reports/highlights",
  trendsOverTime: "/v1/auth/agency/employee/retention-weekly-stats",
  inboxSummary: "/v1/auth/agency/employee/stats-numbers/escalations",
  followUpEscalation: "/v1/auth/agency/employee/escalations/follow-up",
  employeeStatsByRegion: "/v1/auth/agency/employee/stats-numbers/region",
  postRecognition: "/v1/auth/agency/employees/recognition",
  embedAnalytics: "/v1/auth/agency/lightski_jwt",
  employeeRecognitions: "/v1/auth/agency/employees/recognitions",
};

export default endpoints;
